import { t } from "i18next";
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

const BACKENDURL = window.reactInit.backendurl+'/entry';

export default function Application(){

    const navigate = useNavigate();
    // const path = location.pathname.substr(1);

    // const { token } = useAuth();
    // if (!token) navigate('/login');
    const auth = useAuthUser();
    const token = useAuthHeader();
    const [ error, setError ] = useState({});
    const [ submitted, setSubmitted ] = useState(auth.submitted);
    const [ rows, setRows ] = useState([]);

    const [ answers, setAnswers ] = useState([]);

    useEffect(()=>{
        // get completion state.
        // if completed, go to review page.
        fetch(BACKENDURL+'/refresh',{ method:'POST',
                headers:{'Authorization':token} } )
            .then( resp => resp.json() )
            .then( resp => {
                if (resp.status) {
                    console.log('ERROR!',resp.status);
                    setError(resp);
                    return;
                }
                console.log('refresh',resp.email);
                
                let _answers = [];
                let _rows = []
                for (let i=0;i<5;i++){
                    // if (resp["q"+i]) {
                        auth["q"+i] = resp["q"+i];
                        _answers[i] = resp["q"+i];
                    // }
                    _rows[i] = 4;
                }
                auth.submitted = resp.submitted;

                if (auth.submitted) return navigate('/review');

                setAnswers(_answers);
                setRows(_rows);
            } )
            .catch( err => setError(err) );

        
    },[]);

    const handleUpdate = (e) => {
        const v = e.target.value;
        const i = Number(e.target.getAttribute('data-i'));

        const _answers = answers.map( (_answer,_i) => {
            // console.log(_i,i,_answer,v);
            if (_i===i) return v;
            else return _answer;
        })
        // console.log(v,i,_answers[i]);
        setAnswers(_answers);

        // check bounds of text area?
        if (e.target.scrollHeight > e.target.clientHeight) {
            const _rows = rows;
            _rows[i]++;
            setRows(_rows);
        }

        // todo. saving/saved states for answers?
    }
    const handleSave = (e) => {
        const i = Number(e.target.getAttribute('data-i'));
        // if already submitted, disable saving.
        if (submitted) return;
        // console.log('?',i,answers[i],!answers[i]);
        if (!answers[i]) return;
        console.log('save',i);
        const params = {
            email: auth.email,
            num: i,
            val: answers[i]
        };
        fetch(BACKENDURL+'/save',{ method:'POST',
                body:new URLSearchParams(params),
                headers:{'Authorization':token} } )
            .then( resp => resp.json() )
            .then( resp => {
                
                if (resp.success) {
                    // continue. 
                    auth["q"+i] = answers[i];
                } else {
                    console.log('set error',resp.status);
                    const error = {};
                    error['q'+i] = t('errors.'+resp.status);
                    setError(error);
                }
            } )
            .catch( err => setError(err) );
    }

    const validate = ()=>{
        // console.log(auth,token);
        // check if all answers have been saved.
        let invalid = false;
        let _error = [];
        for (let i=0;i<5;i++){
            if (!answers[i]){
                invalid = true;
                _error['q'+i] = true;
            }
        }

        if (invalid) {
            setError(_error);
        } else {
            // go to review.
            navigate('/review');
        }
    }

    return (
        <Container fluid as='main' className="rules">
            <Row className="skinny-row">
                <Col className="text-sm-center">
                    <h2>{t('application.title')}</h2>
                    <p>{t('application.body')}</p>
                </Col>
            </Row>
            <Row className="skinny-row">
                <Col className="form-col py-5 px-3 px-sm-5">
                    <form>
                        {error.status && <p className="error text-center mt-3">{t('errors.'+error.status)}</p>}
                        
                        {[...Array(5)].map((x, i) =>
                            <React.Fragment key={i}>
                                <label htmlFor={`q${i}`} className={error[`q${i}`]&&'error'}>
                                    {t(`application.questions.${i}.q`)}
                                    <br/>
                                    <span className="">{t(`application.questions.${i}.d`)}</span>
                                    </label>
                                <textarea id={`q${i}`} data-i={i} placeholder={t('application.placeholder')} rows={rows[i]} value={answers[i]} onChange={handleUpdate} onBlur={handleSave} className={error[`q${i}`]&&'error'} disabled={submitted}></textarea>
                                { error[`q${i}`] && <span className="error_msg">{error[`q${i}`]}</span> }
                            </React.Fragment>
                        )}
                        <small>{t('register.required')}</small>

                        <input type="button" value={t('application.cta')} onClick={validate} />
                    </form>
                </Col>
            </Row>
        </Container>
    );
}